export default __webpack_public_path__ + "static/media/giveaway-splash-screen.9fc65070.png";